angular.module('main.timestamp', ['timestamping.api','timestamp.userTimeStamping','timestamp.timeStampsAdministration','timestamp.timestampingusers','timestamp.timestampingmanagement']);
